// ClientClassTypography.tsx
import React from 'react';

interface ClientClassTypographyProps {
  clientClass: 'A' | 'B' | 'C' | 'D' | string;
  className?: string; // Optional additional classes
}

export const ClientClassTypography: React.FC<ClientClassTypographyProps> = ({
  clientClass,
  className = '',
}) => {
  // Map the clientClass value to a Tailwind text color class.
  let colorClass = '';
  switch (clientClass) {
    case 'A':
      colorClass = 'text-green-500';
      break;
    case 'B':
      colorClass = 'text-blue-500';
      break;
    case 'C':
      colorClass = 'text-yellow-500';
      break;
    case 'D':
      colorClass = 'text-gray-500';
      break;
    default:
      colorClass = '';
  }

  return (
    <div
      className={`flex h-full items-center justify-center text-[30px] ${colorClass} ${className}`}
    >
      {clientClass}
    </div>
  );
};
